import { render, staticRenderFns } from "./WeightIcon.vue?vue&type=template&id=478ef499&"
import script from "./WeightIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WeightIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports